export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9829.b552739e.jpg";